
import { Component, Vue, Prop } from 'vue-property-decorator'

@Component
export default class TheLoadingIndicator extends Vue {
  @Prop()
  loading!: boolean
}
